__webpack_require__.p = "https://cdn-cosmos.simplersell.com//_next/";